// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../DecimalAmount";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../../../google/protobuf/Timestamp";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        orderId: "0",
        reason: "",
        refundAmount: undefined,
        force: false,
        doManual: false,
        doNotRestoreCoupon: false,
        doNotVoidAuthority: false,
        now: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.orderId !== undefined)
        result.orderId = tsValueToJsonValueFns.int64(value.orderId);
    if (value.reason !== undefined)
        result.reason = tsValueToJsonValueFns.string(value.reason);
    if (value.refundAmount !== undefined)
        result.refundAmount = encodeJson_1(value.refundAmount);
    if (value.force !== undefined)
        result.force = tsValueToJsonValueFns.bool(value.force);
    if (value.doManual !== undefined)
        result.doManual = tsValueToJsonValueFns.bool(value.doManual);
    if (value.doNotRestoreCoupon !== undefined)
        result.doNotRestoreCoupon = tsValueToJsonValueFns.bool(value.doNotRestoreCoupon);
    if (value.doNotVoidAuthority !== undefined)
        result.doNotVoidAuthority = tsValueToJsonValueFns.bool(value.doNotVoidAuthority);
    if (value.now !== undefined)
        result.now = encodeJson_2(value.now);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.orderId !== undefined)
        result.orderId = jsonValueToTsValueFns.int64(value.orderId);
    if (value.reason !== undefined)
        result.reason = jsonValueToTsValueFns.string(value.reason);
    if (value.refundAmount !== undefined)
        result.refundAmount = decodeJson_1(value.refundAmount);
    if (value.force !== undefined)
        result.force = jsonValueToTsValueFns.bool(value.force);
    if (value.doManual !== undefined)
        result.doManual = jsonValueToTsValueFns.bool(value.doManual);
    if (value.doNotRestoreCoupon !== undefined)
        result.doNotRestoreCoupon = jsonValueToTsValueFns.bool(value.doNotRestoreCoupon);
    if (value.doNotVoidAuthority !== undefined)
        result.doNotVoidAuthority = jsonValueToTsValueFns.bool(value.doNotVoidAuthority);
    if (value.now !== undefined)
        result.now = decodeJson_2(value.now);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.orderId !== undefined) {
        const tsValue = value.orderId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.reason !== undefined) {
        const tsValue = value.reason;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.refundAmount !== undefined) {
        const tsValue = value.refundAmount;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.force !== undefined) {
        const tsValue = value.force;
        result.push([4, tsValueToWireValueFns.bool(tsValue)]);
    }
    if (value.doManual !== undefined) {
        const tsValue = value.doManual;
        result.push([5, tsValueToWireValueFns.bool(tsValue)]);
    }
    if (value.doNotRestoreCoupon !== undefined) {
        const tsValue = value.doNotRestoreCoupon;
        result.push([6, tsValueToWireValueFns.bool(tsValue)]);
    }
    if (value.doNotVoidAuthority !== undefined) {
        const tsValue = value.doNotVoidAuthority;
        result.push([7, tsValueToWireValueFns.bool(tsValue)]);
    }
    if (value.now !== undefined) {
        const tsValue = value.now;
        result.push([8, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.orderId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.reason = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.refundAmount = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.force = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.doManual = value;
    }
    field: {
        const wireValue = wireFields.get(6);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.doNotRestoreCoupon = value;
    }
    field: {
        const wireValue = wireFields.get(7);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.doNotVoidAuthority = value;
    }
    field: {
        const wireValue = wireFields.get(8);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.now = value;
    }
    return result;
}
